<template>
  <div class="range-field-container">
    <div class="label-container">
      <p>
        {{ label }}
      </p>

      <p class="second-label">
        {{ secondLabel }}
      </p>
    </div>

    <div class="range-field-content" :class="{ 'disabled': isDisabled }">
      <input
        ref="range"
        type="range"
        :min="min"
        :max="max"
        :step="step"
        v-model="innerValue"
        :disabled="isDisabled"
        :style="{ backgroundSize: backgroundSize }"
        @input="updateSlider"
      >

      <input
        type="number"
        :placeholder="min"
        v-model="inputValue"
        autocomplete="off"
        :disabled="isDisabled"
        @click="clearInput"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SliderField',

    props: {
      label: {
        type: String,
        default: ''
      },

      secondLabel: {
        type: String,
        default: ''
      },

      min: {
        type: Number,
        default: 1
      },

      max: {
        type: Number,
        default: 10
      },

      initialValue: {
        type: [Number, String],
        default: 0
      },

      step: {
        type: Number,
        default: 1
      },

      isDisabled: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        innerValue: 0,
        inputValue: 0,
        backgroundSize: '0% 100%'
      };
    },

    mounted() {
      if (this.initialValue) {
        this.innerValue = this.initialValue;
        this.inputValue = this.initialValue;
      } else {
        this.innerValue = this.min;
        this.inputValue = this.min;
      }

      this.updateBackground();
    },

    watch: {
      innerValue(value) {
        if (!value) {
          this.inputValue = this.min;
        } else {
          this.inputValue = value;
        }

        this.$emit('input', value ? value : this.min);
      },

      inputValue(value) {
        if (!value) {
          this.innerValue = this.min;
        } else {
          this.innerValue = value;

          if (value > this.max) {
            this.innerValue = this.max;
            this.inputValue = this.max;
          }

          if (value < this.min) {
            this.innerValue = this.min;
          }
        }

        this.updateBackground();
      }
    },

    methods: {
      updateSlider() {
        this.updateBackground();
      },

      updateBackground() {
        this.backgroundSize = (this.innerValue - this.min) * 100 / (this.max - this.min) + '% 100%';
      },

      syncValue(value) {
        if (!value) {
          this.innerValue = this.min;
          this.inputValue = this.min;
        } else {
          this.innerValue = value;
          this.inputValue = value;
        }
      },

      clearInput() {
        this.inputValue = '';
      }
    }
  };
</script>

<style lang="scss" scoped>
  .range-field-container {
    .label-container {
      display: flex;

      p {
        &.second-label {
          color: #6D6F6F;
        }

        &:last-child {
          margin-left: auto;
        }
      }
    }

    .range-field-content {
      width: 100%;
      display: flex;
      align-items: center;

      &.disabled {
        opacity: 0.8;

        input {
          &[type=range] {
            &::-webkit-slider-thumb {
              background: #DADADA;
            }
          }
        }
      }

      input {
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        &[type=number] {
          text-align: center;
          margin-left: 0.5rem;
          height: 35px;
          width: 35px;
          background: #FFF;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #DADADA;
          font-size: 14px;
        }

        &[type=range] {
          width: 100%;
          height: 12px;
          border-radius: 5px;
          border: 1px solid #DADADA;
          margin-left: 3px;
          margin-right: 3px;
          background-image: -webkit-gradient(linear, 20% 0%, 20% 100%, color-stop(0%, #FF9C00), color-stop(100%, #FF9C00));
          background-image: -webkit-linear-gradient(left, #FF9C00 0%,#FF9C00 100%);
          background-image: -moz-linear-gradient(left, #FF9C00 0%, #FF9C00 100%);
          background-image: -o-linear-gradient(to right, #FF9C00 0%,#FF9C00 100%);
          background-image: linear-gradient(to right, #FF9C00 0%,#FF9C00 100%);
          background-repeat: no-repeat;
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;

          &:focus {
            outline: none;
          }

          &:focus::-webkit-slider-runnable-track {
            background: transparent;
          }

          &::-webkit-slider-thumb {
            -webkit-appearance: none;
            height: 25px;
            width: 25px;
            border-radius: 50%;
            background: #FF9C00;
            border: 3px solid #FFF;
            cursor: ew-resize;
          }

          &::-webkit-slider-runnable-track  {
            -webkit-appearance: none;
            box-shadow: none;
            border: none;
            background: transparent;
          }

          &:focus::-ms-fill-lower {
            background: transparent;
          }

          &:focus::-ms-fill-upper {
            background: transparent;
          }

          &::-moz-range-track {
            box-shadow: none;
            border: none;
            background: transparent;
          }

          &::-moz-range-thumb {
            height: 18px;
            width: 18px;
            border-radius: 50%;
            background: #FF9C00;
            border: 3px solid #FFF;
            cursor: ew-resize;
          }
        }
      }
    }
  }
</style>